export const HttpErrorsToIgnore = [
  404,
  401
];
